import Vue from 'vue'

export default {
    UPDATE_GROUP (state, value) {
        Vue.set(state, 'groups', value);
    },
    SET_GROUP (state, value) {
        this.commit('UPDATE_GROUP', value);
    },
    SET_SELECTED_GROUP (state,  value ) {
      Vue.set(state, 'selectedGroup', value);
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/groups/mutations.js